import { INVOICE_STATUSES, type InvoiceStatus } from '@nudool/shared';

/** Anything but one of the seven statuses, `ALL` included, reads as no status (the All chip). */
export function parseInvoiceListStatus(raw: unknown): InvoiceStatus | undefined {
  return INVOICE_STATUSES.find((status) => status === raw);
}
